import { render, staticRenderFns } from "./DraggableDataTable.vue?vue&type=template&id=4a4a6a38&scoped=true&"
import script from "./DraggableDataTable.vue?vue&type=script&lang=ts&"
export * from "./DraggableDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableDataTable.vue?vue&type=style&index=0&id=4a4a6a38&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4a6a38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
